"use strict";

var end = {};

module.exports.PublikationResource = {
  author: end,
  foerderer: end,
  forschungsprojekt: end,
  herausgeber: end,
  organisationseinheit: end,
  pubIdent: {
    pubIdentTyp: end
  },
  publicPubIdent: {
    pubIdentTyp: end
  },
  weitereOrganisationseinheiten: end
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/resource/publikation.js
// module id = Vcyx
// module chunks = 0